
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getFeature",
      resolverType: "query",
      routePath: "/getFeature",
      httpMethod: "POST",
    });
  